module.exports = __webpack_public_path__ + "img/upgrade.6c4d18ef.svg";